<div class="login-container">
	@if (showShutdown()) {
		<div class="header shutdown">
			<strong>Application Discontinued</strong>
			<p>This desktop application has been discontinued.</p>
			<p>Please use the new web version of the application instead.</p>
			<p>Contact your system administrator for access to the web application.</p>
			<p>You can find all our web applications at testtools.scania.com</p>
		</div>
	} @else {
		<div class="header">Hold on, we are authenticating you...</div>
		<br />
		<div>
			<p-progressSpinner class="spinner" strokeWidth="4"></p-progressSpinner>
		</div>
	}
</div>
